// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__gImTJ","selected":"Tag_selected__pvym6","deleteButton":"Tag_deleteButton__ujV6S","svgIcon":"Tag_svgIcon__-0zTq"};